import { Box, Card, Stack, Text } from '@mantine/core'
import { PhotoGallery } from '@markku/components'
import type { VisitWithRelations } from '@markku/types'
import { Trans, useLingui } from '@lingui/react/macro'

interface DefectsNotesCardProps {
  visit: VisitWithRelations
}

export function DefectsNotesCard({ visit }: DefectsNotesCardProps) {
  const { t } = useLingui()

  const defectMedia = (visit.attachments || []).filter(
    (a) => a.metadata?.type === 'defect',
  )

  if (!visit.defectsNotes && !defectMedia.length) {
    return null
  }

  return (
    <Card withBorder>
      <Stack gap="md">
        <Text size="lg" fw={600}>
          <Trans>Defects and deficiencies</Trans>
        </Text>

        {visit.defectsNotes && (
          <Box>
            <Text size="sm" c="dimmed">
              {visit.defectsNotes}
            </Text>
          </Box>
        )}

        {defectMedia.length > 0 && (
          <PhotoGallery photos={defectMedia} label={t`Photos and videos`} />
        )}
      </Stack>
    </Card>
  )
}
